export default __webpack_public_path__ + "alberta-logout.ef58e919bef76f1a4410.svg";